export default __webpack_public_path__ + "b9f4799527f42c3be484b91403175c84.svg";